<template>
  <nav v-show="($route.path==='/' || $route.path==='/forgotPassword' || $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path==='/terms' || $route.path.indexOf('/onBoardMember') !== -1)? false : true" class="level app-levelbar">
    <div class="level-right is-hidden-mobile">
      <breadcrumb :list="list" v-show="($route.path==='/home')? false : true"></breadcrumb>
      <nav class="breadcrumb" aria-label="breadcrumbs" v-show="($route.path==='/home')? true : false">
        <ul>
          <li><a href="/home" class="active">Home</a></li>
        </ul>
      </nav>
    </div>
    
    <div class="level-left">
      <div class="level-item">
          {{ msgToUser }}
      </div>
    </div>
  </nav>
  <!--The diagnostic will be automatically submitted on Oct. 19th, 2017-->
</template>

<script>
import Breadcrumb from 'vue-bulma-breadcrumb'

export default {
  components: {
    Breadcrumb
  },

  data () {
    return {
      list: null
    }
  },

  created () {
    // console.log(this.$router.currentRoute)
    this.getList()
  },

  computed: {
    msgToUser () {
      return ''
    }
  },

  methods: {
    getList () {
      let matched = this.$route.matched.filter(item => item.name)
      let first = matched[0]
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/home' }].concat(matched)
      }
      this.list = matched
    }
  },

  watch: {
    $route () {
      this.getList()
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';
@import '~bulma/sass/utilities/mixins';

.app-levelbar {
  margin-bottom: 1rem !important;
  // padding: 0rem .5rem !important;
  .breadcrumb {
    &:not(:last-child) {
      margin-bottom: 0px !important;
    }
    a {
      padding: 0px;
    }
    .active {
      color: #6666ff;
    }
  }

  // @include mobile() {
  //   margin-bottom: 0rem !important;
  // }

  .level-left {
    color: green;
  }
}
</style>



// WEBPACK FOOTER //
// Levelbar.vue?305b1aa0